"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: function () { return ({
            '&:hover': {
                backgroundColor: '#d1e0ec',
            },
        }); },
    });
});
